// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2FrSo","label":"Labeled_label__1JXpv","divider":"Labeled_divider__-LQzO"};